<template>
  <pt-system-customer-table class="pt-system-customer-table__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside" :isAddPageToRouter="isAddPageToRouter">
      <template slot="before">
        <slot name="before"/>
      </template>
      <slot/>
  </pt-system-customer-table>
</template>

<script>
import PtSystemCustomerTable from './index'
export default {
  name: 'pt-system-customer-table__withData',
  components: {
    'pt-system-customer-table': PtSystemCustomerTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    isAddPageToRouter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('systemCustomerList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取系统用户列表失败')
      })
    }

  }
}
</script>
